import { MetadataPlugin } from "./metadata";

export const createScreenResolutionPlugin: MetadataPlugin<number[]> =
  function () {
    function getValue() {
      if (typeof screen === "undefined") {
        return {};
      }

      return {
        screen: [screen.width, screen.height, screen.colorDepth],
      };
    }

    return {
      getValue,
    };
  };
